module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "width": "100%",
      "min-width": "1050px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "UID",
      "min-width": "60px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名",
      "min-width": "70px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "身份"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_time",
      "label": "最后登录时间",
      "min-width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_ip",
      "label": "最后登录ip",
      "min-width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "操作",
      "min-width": "440px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.uid != 1) ? [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.authorizeProduct(scope)
            }
          }
        }, [_vm._v("产品授权")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.authorize(scope)
            }
          }
        }, [_vm._v("用户组授权")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '正常' ? 'warning' : 'success'
          },
          on: {
            "click": function($event) {
              return _vm.forbid(scope)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '正常' ? "禁用" : "恢复"))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.upwd(scope)
            }
          }
        }, [_vm._v("修改密码")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "appDialog",
    attrs: {
      "title": "产品授权",
      "width": "1400px",
      "visible": _vm.editAppListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editAppListVisible = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "tt"
  }, [_vm._v("用户组   \n \t\t\t \t"), _c('el-radio-group', {
    staticStyle: {
      "margin-left": "15px"
    },
    model: {
      value: (_vm.level),
      callback: function($$v) {
        _vm.level = $$v
      },
      expression: "level"
    }
  }, _vm._l((_vm.rule_app_levels), function(item, index) {
    return _c('el-radio', {
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "内部游戏",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "tt"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.checkAll('0')
      }
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.checkCancelAll('0')
      }
    }
  }, [_vm._v("清除")])], 1), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.checkboxInnerAPP),
      callback: function($$v) {
        _vm.checkboxInnerAPP = $$v
      },
      expression: "checkboxInnerAPP"
    }
  }, _vm._l((_vm.appList[0]), function(value, key) {
    return _c('div', {
      staticClass: "plamBox"
    }, [_c('div', {
      staticClass: "innerName"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((value), function(g, index) {
      return _c('el-checkbox', {
        staticClass: "appCheckbox",
        attrs: {
          "label": g.id,
          "border": ""
        }
      }, [_vm._v(_vm._s(g.name))])
    })], 2)
  }), 0)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "外部游戏",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tt"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.checkAll('1')
      }
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.checkCancelAll('1')
      }
    }
  }, [_vm._v("清除")])], 1), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.checkboxOuterAPP),
      callback: function($$v) {
        _vm.checkboxOuterAPP = $$v
      },
      expression: "checkboxOuterAPP"
    }
  }, _vm._l((_vm.appList[1]), function(value, key) {
    return _c('div', {
      staticClass: "plamBox"
    }, [_c('div', {
      staticClass: "innerName"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((value), function(g, index) {
      return _c('el-checkbox', {
        staticClass: "appCheckbox",
        attrs: {
          "label": g.id,
          "border": ""
        }
      }, [_vm._v(_vm._s(g.name))])
    })], 2)
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editAppListVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editAppsSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户组授权",
      "width": "600px",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, _vm._l((_vm.groupList), function(g, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": g.id
      }
    }, [_vm._v(_vm._s(g.title))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增用户",
      "width": "400px",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-position": "top",
      "model": _vm.ruleForm2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "name", $$v)
      },
      expression: "ruleForm2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    on: {
      "click": function($event) {
        return _vm.addSubmit('ruleForm2')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm2')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.updatePwd,
      "width": "400px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updatePwd = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "label-width": "120px",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", $$v)
      },
      expression: "form.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "120px",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkPass", $$v)
      },
      expression: "form.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updatePwd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-71867768"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Table.vue
// module id = 560
// module chunks = 0